<div class="button-close__container">
    <button class="button-close" (click)="close()">
        <ng-container *ngIf="closeSectionData?.closeSectionType === 'icon'">
            <svg-icon src="close"></svg-icon>
        </ng-container>
        <ng-container *ngIf="closeSectionData?.closeSectionType === 'text'">
            <div [innerHTML]="closeSectionData?.closeSectionText | renderLinkTransformer"></div>
        </ng-container>
        <ng-container *ngIf="closeSectionData?.closeSectionType === 'custom' && imageSrc.src">
            <img [src]="imageSrc.src" [attr.alt]="imageSrc.title" [attr.title]="imageSrc.title" />
        </ng-container>
    </button>
</div>
